const initialState = {
  prospectsLoading: false,
  prospectsError: null,
  prospects: [],
  stats: {},
  statsLoading: false,
  statsError: null,
  currentProspectLoading: false,
  currentProspect: null,
  currentProspectError: null,
  createUpdateProspectLoading: false,
  currentComments: [],
  currentCommentsLoading: false,
  commentsLoading: false,
  currentActionsLoading: false,
  prospectUsersLoading: false,
  prospectUsers: [],
  prospectUserLoading: false,
  prospectUser: null,
  createProspectUserLoading: false,
  updateProspectUserLoading: false,
  deleteProspectUserLoading: false,
};

const prospectsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "PROSPECTS_LOADING": {
      return { ...state, prospectsLoading: true, prospectsError: null };
    }
    case "PROSPECTS_ERROR": {
      return { ...state, prospectsLoading: false, prospectsError: payload };
    }
    case "PROSPECTS_CANCELLED": {
      return { ...state, prospectsLoading: false };
    }
    case "PROSPECTS_SUCCESS": {
      return {
        ...state,
        prospectsLoading: false,
        prospects: payload,
      };
    }
    case "PROSPECT_STATS_LOADING": {
      return { ...state, statsLoading: true, statsError: null };
    }
    case "PROSPECT_STATS_ERROR": {
      return { ...state, statsLoading: false, statsError: payload };
    }
    case "PROSPECT_STATS_CANCELLED": {
      return { ...state, statsLoading: false };
    }
    case "PROSPECT_STATS_FETCHED": {
      return { ...state, statsLoading: false, stats: payload };
    }

    case "CURRENT_PROSPECT_LOADING": {
      return { ...state, currentProspectLoading: true };
    }
    case "CURRENT_PROSPECT_SUCCESS": {
      return {
        ...state,
        currentProspectLoading: false,
        currentProspect: payload,
        currentProspectError: null,
      };
    }
    case "CURRENT_PROSPECT_ERROR": {
      return {
        ...state,
        currentProspectLoading: false,
        currentProspectError: payload,
      };
    }

    case "CREATE_UPDATE_PROSPECT_LOADING": {
      return { ...state, createUpdateProspectLoading: true };
    }

    case "CREATE_UPDATE_PROSPECT_SUCCESS": {
      let isFound = false;
      const updatedProspects = state.prospects?.map((item) => {
        if (+item?.id === +payload?.id) {
          isFound = true;
          return {
            ...payload,
            attributes: {
              ...payload.attributes,
              billingAddress:
                payload.currentProspect?.attributes?.billingAddress,
              delivery_addresses:
                state.currentProspect?.attributes?.delivery_addresses,
            },
          };
        }
        return item;
      });
      return {
        ...state,
        prospects: isFound ? updatedProspects : [payload, ...state.prospects],
        currentProspectLoading: false,
        currentProspect: payload,
        currentProspectError: null,
        createUpdateProspectLoading: false,
      };
    }
    case "CREATE_UPDATE_PROSPECT_ERROR": {
      return {
        ...state,
        createUpdateProspectLoading: false,
      };
    }

    case "CREATE_COMMENTS_PROSPECT_LOADING":
      return { ...state, currentCommentsLoading: true };
    case "CREATE_COMMENTS_PROSPECT_SUCCESS":
      return {
        ...state,
        currentCommentsLoading: false,
        currentComments: [payload, ...state.currentComments],
      };

    case "FETCH_COMMENTS_PROSPECT_LOADING":
      return { ...state, commentsLoading: true };

    case "FETCH_COMMENTS_PROSPECT_SUCCESS":
      return { ...state, currentComments: payload, commentsLoading: false };
    case "UPDATE_PROSPECT_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.map((comment) => {
        if (+comment?.id === +payload?.id) {
          return payload;
        }
        return comment;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }
    case "DELETE_PROSPECT_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.filter((comment) => {
        return +comment?.id !== +payload;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }

    case "CREATE_UPDATE_ACTION_LOADING": {
      return { ...state, currentActionsLoading: true };
    }
    case "UPDATE_ACTION_SUCCESS": {
      const updatedProspect = {
        ...state.currentProspect,
        attributes: {
          ...state.currentProspect?.attributes,
          actions: {
            data: state.currentProspect?.attributes?.actions?.data?.map(
              (action) => {
                if (+action?.id === +payload?.id) {
                  return payload;
                }
                return action;
              },
            ),
          },
        },
      };
      return {
        ...state,
        currentProspect: updatedProspect,
        currentActionsLoading: false,
      };
    }
    case "CREATE_ACTION_SUCCESS": {
      const updatedProspect = {
        ...state.currentProspect,
        attributes: {
          ...state.currentProspect?.attributes,
          actions: {
            data: [
              ...(state.currentProspect?.attributes?.actions?.data ?? []),
              payload,
            ],
          },
        },
      };
      return {
        ...state,
        currentProspect: updatedProspect,
        currentActionsLoading: false,
      };
    }

    case "DELETE_ACTION_SUCCESS": {
      const updatedProspect = {
        ...state.currentProspect,
        attributes: {
          ...state.currentProspect?.attributes,
          actions: {
            data: state.currentProspect?.attributes?.actions?.data?.filter(
              (action) => +action?.id !== +payload,
            ),
          },
        },
      };
      return {
        ...state,
        currentProspect: updatedProspect,
        currentActionsLoading: false,
      };
    }

    case "CLEAR_CURRENT_PROSPECT": {
      return {
        ...state,
        currentProspectLoading: false,
        createUpdateProspectLoading: false,
        currentProspect: null,
        currentProspectError: null,
      };
    }

    case "DELETE_PROSPECT_SUCCESS": {
      return {
        ...state,
        prospects: state.prospects.filter(
          (prospect) => +prospect?.id !== +payload,
        ),
        currentProspect:
          state.currentProspect?.id === payload ? null : state.currentProspect,
      };
    }

    case "PROSPECT_USERS_LOADING": {
      return {
        ...state,
        prospectUsersLoading: true,
      };
    }

    case "PROSPECT_USERS_SUCCESS": {
      return {
        ...state,
        prospectUsersLoading: false,
        prospectUsers: payload,
      };
    }

    case "PROSPECT_USERS_ERROR": {
      return {
        ...state,
        prospectUsersLoading: false,
      };
    }
    case "PROSPECT_USER_LOADING": {
      return {
        ...state,
        prospectUserLoading: true,
      };
    }

    case "PROSPECT_USER_SUCCESS": {
      return {
        ...state,
        prospectUserLoading: false,
        prospectUser: payload,
      };
    }

    case "PROSPECT_USER_ERROR": {
      return {
        ...state,
        prospectUserLoading: false,
      };
    }

    case "CREATE_PROSPECT_USER_LOADING":
      return {
        ...state,
        createProspectUserLoading: true,
      };

    case "CREATE_PROSPECT_USER_SUCCESS":
      return {
        ...state,
        createProspectUserLoading: false,
        prospectUsers: [payload, ...state.prospectUsers],
      };
    case "CREATE_PROSPECT_USER_ERROR":
      return {
        ...state,
        createProspectUserLoading: false,
      };
    case "UPDATE_PROSPECT_USER_LOADING":
      return {
        ...state,
        updateProspectUserLoading: true,
      };
    case "UPDATE_PROSPECT_USER_SUCCESS":
      return {
        ...state,
        updateProspectUserLoading: false,
        prospectUsers: state.prospectUsers.map((user) => {
          if (+user.id === +payload.id) {
            return payload;
          }
          return user;
        }),
      };
    case "UPDATE_PROSPECT_USER_ERROR":
      return {
        ...state,
        updateProspectUserLoading: false,
      };

    case "DELETE_PROSPECT_USER_LOADING":
      return {
        ...state,
        deleteProspectUserLoading: true,
      };
    case "DELETE_PROSPECT_USER_SUCCESS":
      return {
        ...state,
        deleteProspectUserLoading: false,
        prospectUsers: state.prospectUsers.filter(
          (user) => +user.id !== +payload,
        ),
      };
    case "DELETE_PROSPECT_USER_ERROR":
      return {
        ...state,
        deleteProspectUserLoading: false,
      };

    case "CLEAR_PROSPECT_USER": {
      return {
        ...state,
        prospectUserLoading: false,
        prospectUser: null,
      };
    }

    default:
      return state;
  }
};

export default prospectsReducer;
